import {
  FETCH_GAS_STATIONS,
  FETCH_GAS_STATION_BY_BULSTAT
} from "@/modules/gas-stations/store/gasstation.module";
import { FETCH_FUELS_TYPES } from "@/modules/fuels-types/store/fuel-type.module";

export const fuelExpenseAiMixin = {
  data() {
    return {
      gasStations: [],
      fuelTypes: []
    };
  },
  methods: {
    async loadFuelDependencies() {
      await Promise.all([this.loadGasStations(), this.loadFuelTypes()]);
    },

    async loadGasStations() {
      try {
        const data = await this.$store.dispatch(FETCH_GAS_STATIONS);
        this.gasStations = data.data.items || data.data || [];
      } catch (error) {
        console.error("Error loading gas stations:", error);
      }
    },

    async loadFuelTypes() {
      try {
        const data = await this.$store.dispatch(FETCH_FUELS_TYPES);
        this.fuelTypes = data.data.items || data.data || [];
      } catch (error) {
        console.error("Error loading fuel types:", error);
      }
    },

    async autoMatchGasStation(form) {
      if (!this.aiInvoiceData) return;

      const supplierVat =
        this.aiInvoiceData.supplierVat || this.aiInvoiceData.supplier?.vat;

      if (supplierVat) {
        const matched = await this.fetchGasStationByBulstat(supplierVat);

        if (matched) {
          form.gasTankStationId = matched.id;
          this.$notify({
            group: "notify",
            type: "success",
            text: this.$t("LABELS.GAS_STATION_AUTO_MATCHED_BY_VAT", {
              name: matched.name,
              vat: supplierVat
            })
          });
          return;
        }
      }
    },

    async fetchGasStationByBulstat(bulstat) {
      if (!bulstat) return null;

      try {
        const response = await this.$store.dispatch(
          FETCH_GAS_STATION_BY_BULSTAT,
          bulstat
        );
        return response.data || response;
      } catch (error) {
        console.error("Error fetching gas station by bulstat:", error);
        return null;
      }
    },

    autoPopulateFuelRows(form) {
      if (!this.aiInvoiceData?.rows || !this.aiInvoiceData.rows.length) return;

      form.rows = this.aiInvoiceData.rows.map(aiRow => {
        const fuelTypeId = this.matchFuelTypeFromItemName(aiRow.itemName);

        return {
          id: null,
          fuelTypeId: fuelTypeId,
          fuelType: this.getFuelTypeName(fuelTypeId),
          totalQty: parseFloat(aiRow.itemQuantity) || 0,
          price: parseFloat(aiRow.itemPrice) || 0,
          totalPrice: parseFloat(aiRow.itemTotalPrice) || 0,
          _aiInvoiceRowId: aiRow.id,
          _aiItemName: aiRow.itemName,
          _aiDiscount: aiRow.itemDiscountPercentage
        };
      });

      form.qty = form.rows.reduce(
        (sum, row) => sum + parseFloat(row.totalQty || 0),
        0
      );
    },

    matchFuelTypeFromItemName(itemName) {
      if (!itemName || !this.fuelTypes.length) return null;

      const name = itemName.toLowerCase();

      const fuelKeywords = {
        дизел: ["дизел", "diesel", "газьол", "gas oil"],
        бензин: ["бензин", "gasoline", "petrol", "а95", "а98", "а100"],
        газ: ["газ", "lpg", "метан", "cng"],
        адблу: ["адблу", "adblue", "ad blue", "def"]
      };

      for (const fuelType of this.fuelTypes) {
        const typeName = fuelType.name.toLowerCase();

        if (name.includes(typeName)) {
          return fuelType.id;
        }

        for (const [key, keywords] of Object.entries(fuelKeywords)) {
          if (typeName.includes(key)) {
            for (const keyword of keywords) {
              if (name.includes(keyword)) {
                return fuelType.id;
              }
            }
          }
        }
      }

      return null;
    },

    getFuelTypeName(fuelTypeId) {
      if (!fuelTypeId) return "";
      const fuelType = this.fuelTypes.find(ft => ft.id === fuelTypeId);
      return fuelType ? fuelType.name : "";
    }
  }
};
